export async function ReadFileToStringAsync(file: File, fileType?: string): Promise<string> {
  const reader = new FileReader();

  if (fileType && file.type !== fileType) {
    console.log(`${fileType} / ${file.type}`)
    throw Error("指定された形式のファイルではありません。")
  }

  return await new Promise<string>((resolve, reject) => {
    reader.onload = () => resolve(reader.result?.toString() ?? "");
    reader.onerror = () => reject(reader.error);
    reader.readAsText(file);
  });
}

export async function ReadFilesToStringAsync(fileList: FileList, fileType?: string): Promise<{ content: string, fileName: string, error?: unknown }[]> {
  return Promise.all(Array.from(fileList).map(async file => {
    try {
      const content = await ReadFileToStringAsync(file, fileType);
      return { content, fileName: file.name, error: undefined };
    } catch (error) {
      return { content: "", fileName: file.name, error }
    }
  }));
}